import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { PbxGroupsService as PbxGroupsApiService } from '../../../api/services/pbx-groups.service';
import { catchError, finalize } from 'rxjs/operators';
import { PbxGroupListModel } from '../../../api/models/pbx-group-list-model';
import { PbxGroupListRequest } from '../../../api/models/pbx-group-list-request';
import { PbxGroupGridResponse } from '../../../api/models/pbx-group-grid-response';

export class PbxGroupsDatasource implements DataSource<PbxGroupListModel> {
  constructor(private pbxApiService: PbxGroupsApiService) {}

  private dataSubject = new BehaviorSubject<PbxGroupListModel[]>([]);
  private dataTotalSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();
  public dataCount$ = this.dataTotalSubject.asObservable();

  connect(collectionViewer: CollectionViewer): Observable<PbxGroupListModel[] | ReadonlyArray<PbxGroupListModel>> {
    console.log('Connecting data source');
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    console.log('Disconnecting data source');
    this.dataSubject.complete();
    this.loadingSubject.complete();
    this.dataTotalSubject.complete();
  }

  public currentPageData(): PbxGroupListModel[] {
    return this.dataSubject.getValue();
  }

  public queryData(state: PbxGroupListRequest): void {
    this.loadingSubject.next(true);

    this.pbxApiService
      .pbxGroupsGetList({ body: state })
      .pipe(
        catchError(() => of({ data: [], total: 0 })),
        finalize(() => this.loadingSubject.next(false)),
      )
      .subscribe((response: PbxGroupGridResponse) => {
        this.dataTotalSubject.next(response.total);
        this.dataSubject.next(response.data);
      });
  }
}
